import { useCallback } from "react";
import { LogIn, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { uuid } from "@/lib/format";
import { openClock } from "@/lib/hr";

export function useClock() {
  const { view, dispatchAs, t } = useApp();
  return useCallback((member) => {
    const open = openClock(view.attendance, member.id);
    const time = new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
    const ok = open
      ? dispatchAs(member, "attendance.out", { id: open.id, staff_name: member.name })
      : dispatchAs(member, "attendance.in", { id: uuid(), staff_id: member.id, staff_name: member.name });
    if (ok) toast.success(`${member.name} · ${t(open ? "clocked_out" : "clocked_in")} ${time}`);
    return ok ? !open : null;
  }, [view.attendance, dispatchAs, t]);
}

export default function ClockButton({ className = "", testid = "clock-btn" }) {
  const { staff, view, t } = useApp();
  const clock = useClock();
  if (!staff) return null;
  const open = openClock(view.attendance, staff.id);
  const since = open ? new Date(open.in_at).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "";
  return (
    <button type="button" onClick={() => clock(staff)} data-testid={testid} title={open ? `${t("clocked_in_since")} ${since}` : t("clock_in")}
      className={`h-10 px-3 rounded border text-xs sm:text-sm font-bold flex items-center gap-1.5 whitespace-nowrap ${open ? "bg-[#E6F4EA] border-[#9CD3AE] text-[#23714A]" : "bg-white border-[#ADADAD] text-[#333]"} ${className}`}>
      {open ? <LogOut className="w-4 h-4" /> : <LogIn className="w-4 h-4" />}{open ? `${t("clock_out")} · ${since}` : t("clock_in")}
    </button>
  );
}
